import { render, staticRenderFns } from "./candidate-components.vue?vue&type=template&id=28ce2482"
import script from "./candidate-components.vue?vue&type=script&lang=js"
export * from "./candidate-components.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports